module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABa0lEQVRYhbWXa66EMAiFDzezL7uzws5wZdwfivHRt/UkTTQde76CFobMDDWJSP1HDYox0vmeiPBrMQ8hvDJelgUiAiIyM7tAFAFExGKMr8z3dbJzWQA3X9f1NUBJ1RQAgKoOLd6ygSYAZu42b32mCWBfsRtiLgAAxAgQpecGAf96H2BmmNllvFFfBE6fE5EA8E/UAAYA6o5EdwRczIDZdYxoKAWUew8G1JeCjWCaOfAqBVskzmNE4wfRpEg0AcwoSK8AZhYk7y28N6iV42nGzHykMoQAIjIAlAUYKUA1ADc/V9cHgIdoNkDK/AEwqwPKKZXSZAq+7oKqAK1q7ZRKTW0RICzbg7qmjVrfkxJoOQKestC3sKoWd90MoCFtUFPX/4hzZ8PM5mObsmnXAO5rXwGYearh/drv3dwByMyO719ELkfmrGvX3k8edZuIcOz8K6nqJex2a2Z/wLcHj6o+dn4WmZlXps+UNSfCP+KvvCAx/Hb6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/MY_PC_32.png
// module id = 87
// module chunks = 0